import { findAuthenticatorById } from 'passkey-authenticator-aaguids';
import {
  AuthenticatorFormFactor,
  FORM_FACTOR_ICONS,
} from './authenticator-form-factor';
import { PLATFORM_AAGUIDS } from './platform-authenticators';

interface ResolveAuthenticatorParams {
  aaguid: string | null;
  backupEligible: boolean;
}

interface ResolveFormFactorParams {
  normalizedAaguid: string | null;
  backupEligible: boolean;
  modelName: string | null;
}

function normalizeAaguid(aaguid: string | null) {
  return aaguid?.trim().toLowerCase() || null;
}

export function getPasskeyAuthenticatorName(aaguid: string | null) {
  const normalizedAaguid = normalizeAaguid(aaguid);

  if (!normalizedAaguid) {
    return null;
  }

  return (
    findAuthenticatorById({ authenticatorId: normalizedAaguid })?.name ?? null
  );
}

function resolveFormFactor({
  normalizedAaguid,
  backupEligible,
  modelName,
}: ResolveFormFactorParams) {
  if (backupEligible) {
    return AuthenticatorFormFactor.PASSWORD_MANAGER;
  }
  if (normalizedAaguid && PLATFORM_AAGUIDS.has(normalizedAaguid)) {
    return AuthenticatorFormFactor.PLATFORM;
  }
  if (modelName) {
    return AuthenticatorFormFactor.SECURITY_KEY;
  }
  return AuthenticatorFormFactor.UNKNOWN;
}

export function resolveAuthenticator({
  aaguid,
  backupEligible,
}: ResolveAuthenticatorParams) {
  const normalizedAaguid = normalizeAaguid(aaguid);
  const modelName = getPasskeyAuthenticatorName(normalizedAaguid);
  const formFactor = resolveFormFactor({
    normalizedAaguid,
    backupEligible,
    modelName,
  });

  return { modelName, formFactor, icon: FORM_FACTOR_ICONS[formFactor] };
}
